import React, { useState } from "react";
import Moment from "react-moment";
const LogsTable = ({
  data,
  isLoading,
  dataType,
  handleFilterCancel,
  pageSize,
  selectedLogId,
  handleSelectLog,
  handleTabSelect,
  handleResetSelection
}) => {
  const columns = [
    {
      path: "id",
      label: "ID",
      content: (row) => (
        <span style={{
          fontWeight: 600,
          color: selectedLogId === row.id ? "#2563eb" : "#64748b",
          fontSize: "12.5px",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px"
        }}>
          {selectedLogId === row.id && (
            <i className="fa fa-check-circle text-primary" style={{ fontSize: "12px" }} />
          )}
          #{row.id}
        </span>
      )
    },
    {
      path: "userid",
      label: "User ID",
      content: (row) => (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: "5px",
          background: "#f1f5f9", border: "1px solid #e2e8f0",
          borderRadius: "6px", padding: "3px 9px",
          fontSize: "12px", fontWeight: 600, color: "#475569"
        }}>
          {row.userid}
        </span>
      )
    },
    {
      path: "userName",
      label: "User Name",
      content: (row) => (
        <span style={{ fontWeight: 600, color: "#1e293b" }}>
          {row.userName}
        </span>
      )
    },
    {
      path: "loginDateTime",
      label: "Login Date & Time",
      content: (row) => (
        <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
            borderRadius: "5px",
            background: "#faf5ff",
            color: "#7c3aed",
            fontSize: "11px",
            flexShrink: 0
          }}>
            <i className="fa fa-calendar-o" />
          </div>
          <span style={{ fontSize: "13px", fontWeight: 600, color: "#475569" }}>
            <Moment format="MM/DD/YYYY, hh:mm A">{row.loginDateTime}</Moment>
          </span>
        </div>
      )
    },
    {
      path: "ipAddress",
      label: "IP Address",
      content: (row) => (
        <span style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          background: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "6px",
          padding: "3px 8px",
          fontFamily: "monospace",
          fontSize: "12px",
          color: "#475569",
          fontWeight: "600"
        }}>
          <i className="fa fa-desktop text-muted" style={{ fontSize: "10px" }} /> {row.ipAddress}
        </span>
      )
    },
    {
      path: "country",
      label: "Country",
      content: (row) => (
        <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569", display: "inline-flex", alignItems: "center", gap: "6px" }}>
          <i className="fa fa-globe text-muted" style={{ fontSize: "11px" }} /> {row.country || "Unknown"}
        </span>
      )
    },
    {
      path: "logoutDateTime",
      label: "Logout DateTime",
      content: (row) => row.logoutDateTime ? (
        <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
            borderRadius: "5px",
            background: "#f0fdf4",
            color: "#16a34a",
            fontSize: "11px",
            flexShrink: 0
          }}>
            <i className="fa fa-calendar-o" />
          </div>
          <span style={{ fontSize: "13px", fontWeight: 600, color: "#475569" }}>
            <Moment format="MM/DD/YYYY, hh:mm A">{row.logoutDateTime}</Moment>
          </span>
        </div>
      ) : (
        <span style={{
          display: "inline-flex", alignItems: "center", gap: "5px",
          background: "#ecfdf5", border: "1px solid #a7f3d0",
          borderRadius: "6px", padding: "3px 9px",
          fontSize: "12px", fontWeight: 600, color: "#047857"
        }}>
          Active Session
        </span>
      )
    },
    {
      path: "",
      label: "Location",
      content: (row) => (
        <button
          type="button"
          className="btn-view-action"
          onClick={(e) => {
            e.stopPropagation();
            handleSelectLog(row);
            handleTabSelect("location");
          }}
        >
          <i className="fa fa-map-marker" /> View
        </button>
      ),
    },
    {
      path: "",
      label: "Browser",
      content: (row) => (
        <button
          type="button"
          className="btn-view-action"
          onClick={(e) => {
            e.stopPropagation();
            handleSelectLog(row);
            handleTabSelect("browser");
          }}
        >
          <i className="fa fa-desktop" /> View
        </button>
      ),
    },
  ];

  return (
    <>
      <table className="table align-items-center table-flush table-striped wf-table">
        <thead className="wf-thead">
          <tr>
            {columns.map(col => (
              <th key={col.label}>
                {col.path === "id" ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span>{col.label}</span>
                    {selectedLogId > 0 && (
                      <span
                        style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleResetSelection();
                        }}
                        title="Reset Selection"
                      >
                        <i className="fa fa-refresh text-primary" style={{ fontSize: "11px" }} aria-hidden="true" />
                      </span>
                    )}
                  </div>
                ) : (
                  col.label
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            Array.from({ length: pageSize > 5 ? 5 : pageSize }).map((_, i) => (
              <tr key={`skel-${i}`} className="skeleton-row">
                <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
              </tr>
            ))
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ padding: 0 }}>
                <div className="wf-empty-state wf-roles-empty-state">
                  <div className="wf-empty-icon">
                    <i className={dataType === "filter" ? "fa fa-search" : "fa fa-list-alt"} />
                  </div>
                  <p className="wf-empty-title">
                    {dataType === "filter" ? "No Matching Logs" : "No Monitoring Logs Found"}
                  </p>
                  <p className="wf-empty-desc">
                    {dataType === "filter"
                      ? "Try adjusting or resetting the filters to see monitoring logs."
                      : "There are no monitoring logs available in this system yet."}
                  </p>
                  {dataType === "filter" && (
                    <button
                      className="btn-action-search"
                      onClick={handleFilterCancel}
                      style={{ marginTop: 8 }}
                    >
                      <i className="fa fa-refresh" aria-hidden="true" />
                      Reset Filters
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            data.map((row) => (
              <tr
                key={row.id}
                className={`wf-table-row ${selectedLogId === row.id ? "selected-row" : ""}`}
                onClick={() => handleSelectLog(row)}
                title={selectedLogId === row.id ? `Click to deselect: ${row.userName}` : `Click to select: ${row.userName}`}
              >
                {columns.map((col) => (
                  <td key={col.label}>
                    {col.content ? col.content(row) : row[col.path]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </>
  );
};

export default LogsTable;
